import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { 

  }

  getCountries(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.countries}`);
  }

  getIdTypes(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.tipoIdentificacion}`);
  }  

  actionCntrtsAllSteps(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.actionCntrtsAllSteps}`, data);
  }

  actionUploadFile(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.actionUploadFile}`, data);
  }
  
  getTypesAddress(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.typesAddress}`);
  }

  getOccupations(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.occupations}`);
  }

  getCivilStatus(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.civilStatus}`);
  }

  getCatCountries(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catCountries}`);
  }

  getCatEstates(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catEstates}`);
  }

  getCatSuburbs(data): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catSuburbs}`,{params:data});
  }

  getCatRelationship(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catRelationship}`);
  }

  getCitiesByCode(data): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catCitiesByCode}`,{params:data});
  }

  getTownsByCode(data): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catTownsByCode}`,{params:data});
  }

  getSuburbsByCode(data): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catSuburbsByCode}`,{params:data});
  }

  getCatAddress(): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.catTypeAddress}`);
  }

  addBeneficiary(data): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.addBeneficiary}`,{params:data});
  }

  updateBeneficiary(data): Observable<any> {
    return this.http.get<any>(`${environment.api_url}${environment.services.updateBeneficiary}`,{params:data});
  }

  saveStepOne(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.saveStepOne}`, data);
  }

  saveStepTwo(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.saveStepTwo}`, data);
  }

  saveStepThree(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.saveStepThree}`, data);
  }

  saveStepFour(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.saveStepFour}`, data);
  }

  saveAllSteps(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}${environment.services.saveAllSteps}`, data);
  }

  getToken():Observable<any> {
    const params = {};    
    let url = window.location.origin;
    if(url.indexOf('bursanet.mx') > 0) {
      const httpOptions = {
        headers: new HttpHeaders(environment.headers_token_prod)
      };
      return this.http.post<any>(`${environment.api_url_bursanet_prod}${environment.services_api.accesstoken}`, params, httpOptions);
    } else {
      const httpOptions = {
        headers: new HttpHeaders(environment.headers_token)
      };
      return this.http.post<any>(`${environment.api_url_bursanet_qa}${environment.services_api.accesstoken}`, params, httpOptions);
    }
    
  }
  
  prospectClientRegistration(data, token, cellPhone): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'})
    };
    let url = window.location.origin;
    if(url.indexOf('bursanetmx-qa') > 0) {
      return this.http.patch<any>(`${environment.api_url_bursanet_qa}${environment.services_api.accountBursanet}${cellPhone}`, data, httpOptions);
    } else {
      return this.http.patch<any>(`${environment.api_url_bursanet_prod}${environment.services_api.accountBursanet}${cellPhone}`, data, httpOptions);
    }    
  }

}
